module.exports = __webpack_public_path__ + "static/media/how-it-works-phone_graphic.a685104d.png";